var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.828,
    height: 24.828,
    viewBox: "0 0 24.828 24.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(-1188.086 -295.086)",
    opacity: 0.573
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_524",
    "data-name": "Line 524",
    x2: 22,
    y2: 22,
    transform: "translate(1189.5 296.5)",
    fill: "none",
    stroke: "#d3e4e6",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_525",
    "data-name": "Line 525",
    x1: 22,
    y2: 22,
    transform: "translate(1189.5 296.5)",
    fill: "none",
    stroke: "#d3e4e6",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGrey);
export default __webpack_public_path__ + "static/media/CrossGrey.ead515f1face25fce5e049f981217a77.svg";
export { ForwardRef as ReactComponent };